import { createServerFn } from "@tanstack/react-start";

interface MakeWebhookInput {
  source?: string;
  firstName?: string;
  first_name?: string;
  lastName?: string;
  last_name?: string;
  email?: string;
  phone?: string;
  address?: string;
  city?: string;
  state?: string;
  zipCode?: string;
  zip_code?: string;
  conversationSummary?: string;
}

export const makeWebhook = createServerFn({ method: "POST" })
  .inputValidator((input: unknown): MakeWebhookInput => {
    return (input ?? {}) as MakeWebhookInput;
  })
  .handler(async ({ data: formData }) => {
    if (!formData.email && !formData.phone) {
      // Preserve legacy behavior: drop silently instead of erroring the client
      return { success: true, webhook: false, reason: "missing_contact" };
    }
    const webhookUrl = process.env['MAKE_HERO_FORM_WEBHOOK_URL'];

    if (!webhookUrl) {
      // Webhook not configured - return success so form still works
      return { success: true, webhook: false, reason: "not_configured" };
    }

    try {
      // Forward to Make.com webhook
      const makeResponse = await fetch(webhookUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          timestamp: new Date().toISOString(),
          source: formData.source || "hero_form",
          first_name: formData.firstName || formData.first_name || "",
          last_name: formData.lastName || formData.last_name || "",
          email: formData.email || "",
          phone: formData.phone || "",
          address: formData.address || "",
          city: formData.city || "",
          state: formData.state || "",
          zip_code: formData.zipCode || formData.zip_code || "",
        }),
      });

      if (!makeResponse.ok) {
        console.error("Make.com webhook error:", makeResponse.status);
        return { success: true, webhook: false, reason: "webhook_error" };
      }

      return { success: true, webhook: true };
    } catch (error) {
      console.error("Webhook forward error:", error);
      return { success: true, webhook: false, reason: "error" };
    }
  });
